import { renderSlot as _renderSlot, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-994d595c")

_pushScopeId("data-v-994d595c")
const _hoisted_1 = { class: "aw-modal" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.shown)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "aw-modal-container",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args)), ["stop"]))
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", {
            class: "aw-modal-body",
            style: { width: _ctx.getWidth() },
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 4)
        ])
      ]))
    : _createCommentVNode("", true)
})